import { IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS } from '../actionTypes/PromotionalBannerActionTypes';

function IrisPromotionalBannerReducer(state = [], action) {
    switch (action.type) {
        case IRIS_PROMOTIONALBANNERDATA_GET_SUCCESS:
            return {
                content: action.irisPromotionalBannerData,
                isReady: true,
            };
        default:
            return state;
    }
}

IrisPromotionalBannerReducer.reducerName = 'irisPromotionalBannerData';

export default IrisPromotionalBannerReducer;
